import React, { useState } from "react";
import { FaSearch, FaRegFilePdf } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Modal from "react-modal";
import Logo from "./logo192.png";
import "./UnifiedSearchModalDesk.css";
import axios from "axios";
import Fuse from "fuse.js";

const UnifiedSearchModalDesk = ({ Ip }) => {
  const [showModal, setShowModal] = useState(false);
  const [searchInput, setSearchInput] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [pageResults, setPageResults] = useState([]);
  const [docResults, setDocResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSearch = async () => {
    setSearchInput(true);

    if (!searchText.trim()) {
      setSearchInput(!searchInput);
      return;
    }

    setShowModal(true);
    setLoading(true);
    setPageResults([]);
    setDocResults([]);

    try {
      const formData = new FormData();
      formData.append("Action", "search");
      formData.append("text", searchText);
      const [pageRes, docRes] = await Promise.all([
        axios.get(`${Ip}controllers/searchData.php`),
        axios.post(`${Ip}controllers/search.php`, formData),
      ]);

      const pagesData = pageRes.data || [];
      const fuse = new Fuse(pagesData, {
        keys: ["title", "keywords"],
        threshold: 0.3,
        ignoreLocation: true,
        includeScore: true,
      });

      const filteredPages = fuse
        .search(searchText)
        .sort((a, b) => a.score - b.score)
        .map((result) => result.item);
      const docs = docRes.data || [];

      setPageResults(filteredPages);
      setDocResults(docs);
    } catch (error) {
      console.error("Search error:", error);
      setPageResults([]);
      setDocResults([]);
    } finally {
      setLoading(false);
    }
  };

  const closeModal = () => {
    setShowModal(false);
  };
  // const handlePageClick = (url) => {
  //   closeModal();
  //   setTimeout(() => navigate(url), 0);
  // };
  const handlePageClick = (item) => {
    closeModal();
    setTimeout(() => {
      navigate(item.url, { state: { selectedSlide: item.slideIndex } });
    }, 0);
  };

  const handlePdfClick = (title) => {
    closeModal();
    setTimeout(
      () =>
        navigate(`/V-CIS?searchText=${encodeURIComponent(title)}#media_vcis`),
      0
    );
  };

  return (
    <>
      <div className="search-wrapper">
        <FaSearch className="search-icon" onClick={handleSearch} />
        {searchInput && (
          <input
            className="search-input-new"
            placeholder="Search ..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleSearch()}
            autoFocus
          />
        )}
      </div>

      <Modal
        isOpen={showModal}
        onRequestClose={closeModal}
        contentLabel="Search Results"
        className={{
          base: "unified-search-modal",
        }}
        overlayClassName={{
          base: "unified-search-overlay",
        }}
        ariaHideApp={false}
      >
        <span
          onClick={closeModal}
          style={{
            cursor: "pointer",
            position: "absolute",
            right: "8px",
            fontSize: "1.5rem",
            zIndex: 10,
          }}
        >
          ×
        </span>

        <div>
          <div
            style={{
              display: "flex",
              gap: "2rem",
              flexDirection: window.innerWidth < 600 ? "column" : "row",
              minHeight: "350px",
            }}
          >
            {/* Website Pages */}
            <div
              style={{
                flex: 1,
                borderRight:
                  window.innerWidth < 600 ? "none" : "1px solid #eee",
                paddingRight: window.innerWidth < 600 ? "0" : "1rem",
                marginBottom: window.innerWidth < 600 ? "1rem" : "0",
              }}
            >
              <h4>Website Pages</h4>
              {loading ? (
                <p>Loading...</p>
              ) : pageResults.length === 0 ? (
                <p>No pages found.</p>
              ) : (
                <div style={{ maxHeight: 350, overflowY: "auto" }}>
                  {pageResults.map((item, idx) => (
                    <div
                      key={idx}
                      onClick={() => handlePageClick(item)}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        padding: 8,
                        marginBottom: 8,
                        background: "#f8f8f8",
                        borderRadius: 8,
                        cursor: "pointer",
                      }}
                    >
                      <img
                        src={item.image || Logo}
                        alt="Page"
                        style={{ width: 30, marginRight: 8 }}
                      />
                      <div>
                        <h5 className="result-title">{item.title}</h5>
                        {item.keywords && (
                          <p style={{ fontSize: 12 }}>
                            {(() => {
                              const text = item.keywords.slice(0, 3).join(", ");
                              return text.length > 100
                                ? text.slice(0, 100) + "..."
                                : text;
                            })()}
                          </p>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Documents */}
            <div
              style={{
                flex: 1,
                paddingLeft: window.innerWidth < 600 ? "0" : "1rem",
              }}
            >
              <h4>Documents</h4>
              {loading ? (
                <p>Loading...</p>
              ) : docResults.length === 0 ? (
                <p>No documents found.</p>
              ) : (
                <div style={{ maxHeight: 350, overflowY: "auto" }}>
                  {docResults.map((item, idx) => (
                    <div
                      key={idx}
                      onClick={() => handlePdfClick(item.doc_name)}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        padding: 8,
                        marginBottom: 8,
                        background: "#f8f8f8",
                        borderRadius: 8,
                        cursor: "pointer",
                      }}
                    >
                      <FaRegFilePdf
                        color="#d32f2f"
                        size={20}
                        style={{ marginRight: 8 }}
                      />
                      <div>
                        <h5 className="result-title">{item.doc_name}</h5>
                        <p style={{ fontSize: 12 }}>{item.subtitle}</p>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default UnifiedSearchModalDesk;
